export default __webpack_public_path__ + "static/media/google-play.de7748a0.png";